import {
  useOpenCollaborationInsightsFunnel,
  useOpenCollaborationInsightsPerformance,
  useOpenCollaborationInsightsRelationships,
  useOpenCollaborationInsightsSummary,
} from "@/api/collaborations";
import type { CreatorStatusTab } from "../collaboration-table-columns";
import { CollaborationInsightsPanelView } from "./collaboration-insights-panel-view";

type Props = {
  collaborationId: string | undefined;
  showRecommendations?: boolean;
  onFilterChange?: (status: CreatorStatusTab) => void;
  onBreakdownFilterChange?: (bucket: string | null) => void;
};

export function OpenCollaborationInsightsPanel({
  collaborationId,
  showRecommendations,
  onFilterChange,
  onBreakdownFilterChange,
}: Props) {
  const summaryQuery = useOpenCollaborationInsightsSummary(collaborationId);
  const funnelQuery = useOpenCollaborationInsightsFunnel(collaborationId);
  const relationshipsQuery = useOpenCollaborationInsightsRelationships(collaborationId);
  const performanceQuery = useOpenCollaborationInsightsPerformance(collaborationId, "accepted");

  return (
    <CollaborationInsightsPanelView
      summaryQuery={summaryQuery}
      funnelQuery={funnelQuery}
      relationshipsQuery={relationshipsQuery}
      performanceQuery={performanceQuery}
      recommendationsCollaborationId={collaborationId}
      collaborationType="open"
      showRecommendations={showRecommendations}
      showModeToggle={false}
      performanceMode="accepted"
      onPerformanceModeChange={() => {}}
      onFilterChange={onFilterChange}
      onBreakdownFilterChange={onBreakdownFilterChange}
    />
  );
}
